import React, { FunctionComponent, useRef, memo } from "react";
import { Box } from "@chakra-ui/react";
import { isEqual } from "lodash";
import "./dashboard.scss";

import Measurements from "./Measurements";
import Flows from "./Flows";
import Controls from "./Controls";
import {
  SiteConfig_siteConfig_dashboardConf,
  SiteConfig_siteConfig_manualControlConf,
  SiteConfig_siteConfig_modesConf,
} from "graphql/generated";
import { useLiveMeasurements } from "scenes/site/hooks";

interface IProps {
  siteId: string;
  dashboardConf: SiteConfig_siteConfig_dashboardConf;
  modesConf: SiteConfig_siteConfig_modesConf;
  manualControlConf: SiteConfig_siteConfig_manualControlConf;
}

const Dashboard: FunctionComponent<IProps> = memo(function Dashboard({
  siteId,
  manualControlConf,
  modesConf,
  dashboardConf,
}) {
  const { data } = useLiveMeasurements(siteId, "dashboard");
  const measurementsRef = useRef<HTMLDivElement>(null);

  return (
    <Box minW="min-content">
      <Flows
        gridWidth={dashboardConf.gridWidth}
        gridHeight={dashboardConf.gridHeight}
        components={dashboardConf.components}
        connections={dashboardConf.connections}
        flows={data?.flows?.flows}
        containerRef={measurementsRef}
      />
      <Measurements
        siteId={siteId}
        gridWidth={dashboardConf.gridWidth}
        gridHeight={dashboardConf.gridHeight}
        components={dashboardConf.components}
        data={data}
        containerRef={measurementsRef}
      />
      <Controls
        siteId={siteId}
        manualControlConf={manualControlConf}
        modesConf={modesConf}
        state={data?.modes}
      />
    </Box>
  );
}, isEqual);

export default Dashboard;
